module.exports = __webpack_public_path__ + "55df8ee3076c88ec443405e03ffa292d.svg";